<template>
    <!-- Mobile Menu Bar -->
    <div class="bg-primary text-white py-4 flex items-center justify-between md:hidden">
        <!-- Logo -->
        <Link :href="route('admin.dashboard')">
            <AppLogo class="px-6"></AppLogo>
        </Link>
        <button v-on:click="mobileNavToggle" class="mobile-menu-button p-4 focus-outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
        </button>
    </div>
    <!-- Sidebar -->
    <div class="sidebar bg-primary text-white w-64 px-4 py-6 space-y-6 absolute inset-y-0 left-0 transform -translate-x-full md:relative md:translate-x-0 transition duration-200 ease-in-out z-50">
        <!-- Logo -->
        <Link :href="route('admin.dashboard')">
            <AppLogo></AppLogo>
        </Link>
        <nav>
            <Link :href="route('admin.dashboard')"
                  class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold"
                  :class="{'bg-white text-primary font-bold': $page.url === '/admin' }">Home
            </Link>
            <Link href="/admin/awards" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/awards') }">Awards</Link>
            <Link href="/admin/award-groups" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/award-groups') }">Award Groups</Link>
            <Link href="/admin/brands" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/brands') }">Brands</Link>
            <Link href="/admin/manufacturers" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/manufacturers') }">Manufacturers</Link>
            <Link href="/admin/models" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/models') }">Models</Link>
            <Link href="/admin/products" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/products') }">Products</Link>
            <Link href="/admin/questions" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/questions') }">Questions</Link>
            <Link href="/admin/reviews" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/reviews') }">Reviews</Link>
            <Link href="/admin/feedback" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/feedback') }">Feedback</Link>
            <Link href="/admin/review-posts" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/review-posts') }">Review Posts</Link>
            <Link href="/admin/pages" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/pages') }">Pages</Link>
            <Link href="/admin/comparisons" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/comparisons') }">Comparisons</Link>
            <Link href="/admin/advice" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/advice') }">Advice</Link>
            <Link href="/admin/news"
                  class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold"
                  :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/news') }">News
            </Link>
            <Link href="/admin/users" class="block py-2.5 px-4 hover:bg-white hover:text-primary hover:font-bold" :class="{'bg-white text-primary font-bold': $page.url.startsWith('/admin/users') }">Users</Link>
        </nav>
        <div class="absolute bottom-0 left-0 w-full">
            <div class="px-4">
                <hr class="border-white mb-4" />
                <Link as="button" href="/admin/logout" class="block w-full text-left py-2.5 px-4 hover:bg-purple-300" method="post">Logout</Link>
            </div>
        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3';
import AppLogo from "@/Components/AppLogo";
export default {
    components: {AppLogo, Link},
    methods: {
        mobileNavToggle: function(event)
        {
            const sidebar = document.querySelector('.sidebar');
            let button = event.target;

            sidebar.classList.toggle("-translate-x-full");
        }
    }
}
</script>
